export const getUserServiceUrl = (): string => {
  const url = process.env.NEXT_PUBLIC_AUTH_SERVICE_URL

  if (!url) {
    throw new Error(
      'NEXT_PUBLIC_AUTH_SERVICE_URL environment variable is not set',
    )
  }

  return url
}
